import useApiQuery from 'shared/hooks/use-api-query';
import {AdditionalGroupProps} from '../types';
import {AdditionalProps} from 'modules/additionals/types';
import {SelectDataProps} from 'shared/types/select-data';

const useAdditionalGroupsByCompanySelect = (companyId?: string) => {
  const {data = [], ...rest} = useApiQuery({
    url: `/additional-groups/companies/${companyId}`,
    enabled: !!companyId,
  });

  return {
    ...rest,
    data: data.map(
      (
        additionalGroup: AdditionalGroupProps & {
          additionals: AdditionalProps[];
        },
      ) => ({
        label: additionalGroup.description,
        value: additionalGroup.id,
        data: additionalGroup.additionals,
      }),
    ) as SelectDataProps<AdditionalProps[]>[],
  };
};

export default useAdditionalGroupsByCompanySelect;
